export const developementConnectionsData = [
    {
        imgSrc: '/images/brand/google-drive.png',
        title: 'Google Drive: Cloud Storage & File Sharing',
        description: "Google's powerful search capabilities are embedded in Drive and offer speed, reliability, and collaboration. And features like Drive search chips help your team ...",
        isChecked: false,
    },
    {
        imgSrc: '/images/brand/dropbox.png',
        title: 'Dropbox: Cloud Storage & File Sharing',
        description: 'Dropbox brings everything—traditional files, cloud content, and web shortcuts—together in one place. ... Save and access your files from any device, and share ...',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/github.png',
        title: 'GitHub: Where the world builds software',
        description: 'GitHub is where over 83 million developers shape the future of software, together. Contribute to the open source community, manage your Git repositories, ...',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/gitlab.png',
        title: 'GitLab: The One DevOps Platform',
        description: 'GitLab helps you automate the builds, integration, and verification of your code. With SAST, DAST, code quality analysis, plus pipelines that enable ...',
        isChecked: false,
    },
    {
        imgSrc: '/images/brand/shopify.png',
        title: 'Shopify: Ecommerce Developers Platform',
        description: 'Try Shopify free and start a business or grow an existing one. Get more than ecommerce software with tools to manage every part of your business.',
        isChecked: true,
    },
    {
        imgSrc: '/images/brand/whatsapp.png',
        title: 'WhatsApp: WhatsApp from Facebook is a FREE messaging and video calling app',
        description: "Reliable messaging. With WhatsApp, you'll get fast, simple, secure messaging and calling for free*, available on phones all ...",
        isChecked: false,
    },
];